export enum FileTypeEnum {
    IMAGE = 'image',
    DOCUMENT = 'document',
}
